exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-company__add-wrapper[data-v-15ccd09d] {\n  color: #9ba3af;\n  font-size: 12px;\n  margin-top: 10px;\n}\n.custom-company__add[data-v-15ccd09d] {\n  border: 0;\n  border-bottom: 1px dotted;\n  padding: 0;\n  margin: 0;\n  background: none;\n}\n.custom-company__add[data-v-15ccd09d]:hover {\n  border-bottom-color: transparent;\n}\n.custom-company__row[data-v-15ccd09d] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n}\n@media (min-width: 768px) {\n.custom-company__row[data-v-15ccd09d] {\n    flex-direction: row;\n}\n}\n", ""]);

// exports
